import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { toastSlice } from '../entities/toast'
import { slideSlice } from '../entities/slide'
import { layerSlice } from '../entities/layer'
import { editorSyncSlice } from '../entities/editorSync'

const editorReducer = combineReducers({
  slides: slideSlice.reducer,
  layers: layerSlice.reducer,
  sync: editorSyncSlice.reducer,
})

const editorPersistConfig = {
  key: 'editor',
  storage,
  whitelist: ['slides', 'layers', 'sync'],
}

export const rootReducer = combineReducers({
  toast: toastSlice.reducer,
  editor: persistReducer(editorPersistConfig, editorReducer),
})

// Setup Redux Store
export type RootState = ReturnType<typeof rootReducer>

export const createStore = (state: Partial<RootState> = {}) => configureStore({
  reducer: rootReducer,
  preloadedState: state,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const store = createStore()
export const persistor = persistStore(store)
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
